/* eslint-disable */
import { APIService } from '@/service/api.js'
import urlConstant from '@/constants/uri.constants.js'
import Cookies from 'js-cookie'

const state = {
  cityList: [],
  offshoreCityList: [],
  localityList: [],
  databasePlans: [],
  premiumPlans: [],
  functionalAreaList: [],
  industriesList: [],
  industriesListNew: [],
  newIndustriesList: [],
  educationList: [],
  skillList: [],
  suggestedSkill: [],
  specialPlan: {},
  industrialAreaList: {},
  submitPostJobRes: {},
  submitOffshorePostJobRes: {},
  submitPostContractJobRes: {},
  verifyPostJobRes: {},
  postJobListRes: {},
  numOfApplicationsRes: {},
  postContractJobListRes: {},
  feedbacksListRes: {},
  updateExistingJobRes: {},
  addFeedback: {},
  JobFeedbackStatus: {},
  deleteJOb: {},
  jobDetail: {},
  contractJobDetail: {},
  updateJob: {},
  updateJobStatus: {},
  activateToPaid: {},
  pinToTop: {},
  updateOrderSuccess: {},
  contactUs: {},
  resendOtpResponse: {},
  gstVerifyResponse: {},
  gstUploadResponse: {},
  checkViewJob: {},
  viewResumeMobile: {},
  getResumeCallback: {},
  viewWhatsapp: {},
  findResumeData: [],
  resumeList: [],
  allSkillsList: [],
  allLocations: [],
  skillObjs: {},
  matchResumeList: {},
  exactMatchResumeList: {},
  shortlistJobResponse: {},
  removeJobResponse: {}
}

const mutations = {
  fetchCitySearch(state, payload) {
    switch (payload.type) {
      case 'FETCHING_CITY_SEARCH':
        state.cityList = {
          isFechingCities: true,
          errorFechingCities: false,
          responseData: {}
        }
        break
      case 'FETCHED_CITY_SEARCH':
        state.cityList = {
          isFechingCities: false,
          errorFechingCities: false,
          responseData: payload.data.data?.locations
        }
        break
    }
  },

  fetchOffshoreCitySearch(state, payload) {
    switch (payload.type) {
      case 'FETCHING_OFFSHORE_CITY_SEARCH':
        state.offshoreCityList = {
          isFechingOffshoreCities: true,
          errorFechingOffshoreCities: false,
          responseData: {}
        }
        break
      case 'FETCHED_OFFSHORE_CITY_SEARCH':
        state.offshoreCityList = {
          isFechingOffshoreCities: false,
          errorFechingOffshoreCities: false,
          responseData: payload.data.data?.locations
        }
        break
    }
  },

  fetchLocalitySearch(state, payload) {
    switch (payload.type) {
      case 'FETCHING_LOCALITY_SEARCH':
        state.localityList = {
          isFechingLocalities: true,
          errorFechingLocalities: false,
          responseData: {}
        }
        break
      case 'FETCHED_LOCALITY_SEARCH':
        state.localityList = {
          isFechingLocalities: false,
          errorFechingLocalities: false,
          responseData: payload.data.data?.locations
        }
        break
    }
  },

  fetchDatabasePlan(state, payload) {
    switch (payload.type) {
      case 'FETCHING_DATABASE_PLAN':
        state.databasePlans = {
          isFechingDatabasePLan: true,
          errorFechingDatabasePLan: false,
          responseData: {}
        }
        break
      case 'FETCHED_DATABASE_PLAN':
        state.databasePlans = {
          isFechingDatabasePLan: false,
          errorFechingDatabasePLan: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchPremiumPlan(state, payload) {
    switch (payload.type) {
      case 'FETCHING_PREMIUM_PLAN':
        state.premiumPlans = {
          isFechingPremiumPLan: true,
          errorFechingPremiumPLan: false,
          responseData: {}
        }
        break
      case 'FETCHED_PREMIUM_PLAN':
        state.premiumPlans = {
          isFechingPremiumPLan: false,
          errorFechingPremiumPLan: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchSpecialPlan(state, payload) {
    switch (payload.type) {
      case 'FETCHING_SPECIAL_PLAN':
        state.specialPlan = {
          isFechingSpecialPLan: true,
          errorFechingSpecialPLan: false,
          responseData: {}
        }
        break
      case 'FETCHED_SPECIAL_PLAN':
        state.specialPlan = {
          isFechingSpecialPLan: false,
          errorFechingSpecialPLan: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchFunctionalAreas(state, payload) {
    switch (payload.type) {
      case 'FETCHING_FUNC_AREA':
        state.functionalAreaList = {
          isFechingFuncArea: true,
          errorFechingFuncArea: false,
          responseData: {}
        }
        break
      case 'FETCHED_FUNC_AREA':
        state.functionalAreaList = {
          isFechingFuncArea: false,
          errorFechingFuncArea: false,
          responseData: payload.data.data.functionalArea
        }
        break
    }
  },

  fetchIndustries(state, payload) {
    switch (payload.type) {
      case 'FETCHING_INDUSTRIES':
        state.industriesList = {
          isFechingIndustries: true,
          errorFechingIndustries: false,
          responseData: {}
        }
        break
      case 'FETCHED_INDUSTRIES':
        state.industriesList = {
          isFechingIndustries: false,
          errorFechingIndustries: false,
          responseData: payload.data.data.industry
        }
        break
    }
  },
  fetchIndustriesList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_INDUSTRIES_LIST':
        state.industriesListNew = {
          isFechingIndustries: true,
          errorFechingIndustries: false,
          responseData: {}
        }
        break
      case 'FETCHED_INDUSTRIES_LIST':
        state.industriesListNew = {
          isFechingIndustries: false,
          errorFechingIndustries: false,
          responseData: payload.data.data.industries
        }
        break
    }
  },
  // fetchNewIndustries(state, payload) {
  //   switch (payload.type) {
  //     case "FETCHING_NEW_INDUSTRIES":
  //       state.newIndustriesList = {
  //         isFechingNewIndustries: true,
  //         errorFechingNewIndustries: false,
  //         responseData: {},
  //       };
  //       break;
  //     case "FETCHED_NEW_INDUSTRIES":
  //       state.newIndustriesList = {
  //         isFechingNewIndustries: false,
  //         errorFechingNewIndustries: false,
  //         responseData: payload.data.data.industry,
  //       };
  //       break;
  //   }
  // },
  fetchAllSkills(state, payload) {
    switch (payload.type) {
      case 'FETCHING_ALL_SKILLS':
        state.allSkillsList = {
          isFechingAllSkills: true,
          errorFechingAllSkills: false,
          responseData: {}
        }
        break
      case 'FETCHED_ALL_SKILLS':
        state.allSkillsList = {
          isFechingAllSkills: false,
          errorFechingAllSkills: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchAllLocations(state, payload) {
    // console.log("---payload---", payload);
    switch (payload.type) {
      case 'FETCHING_ALL_LOCATIONS':
        state.allLocations = {
          isFechingAllSkills: true,
          errorFechingAllSkills: false,
          responseData: {}
        }
        break
      case 'FETCHED_ALL_LOCATIONS':
        state.allLocations = {
          isFechingAllSkills: false,
          errorFechingAllSkills: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchEducations(state, payload) {
    switch (payload.type) {
      case 'FETCHING_EDUCATION':
        state.educationList = {
          isFechingEducation: true,
          errorFechingEducation: false,
          responseData: {}
        }
        break
      case 'FETCHED_EDUCATION':
        state.educationList = {
          isFechingEducation: false,
          errorFechingEducation: false,
          responseData: payload.data.data.qualification
        }
        break
    }
  },
  fetchSkills(state, payload) {
    switch (payload.type) {
      case 'FETCHING_SKILLS':
        state.skillList = {
          isFechingSkills: true,
          errorFechingSkills: false,
          responseData: {}
        }
        break
      case 'FETCHED_SKILLS':
        state.skillList = {
          isFechingSkills: false,
          errorFechingSkills: false,
          responseData: payload.data.data.skills
        }
        break
    }
  },

  fetchSuggestedSkills(state, payload) {
    switch (payload.type) {
      case 'FETCHING_SKILLS':
        state.suggestedSkill = {
          isFechingSkills: true,
          errorFechingSkills: false,
          responseData: {}
        }
        break
      case 'FETCHED_SKILLS':
        state.suggestedSkill = {
          isFechingSkills: false,
          errorFechingSkills: false,
          responseData: payload.data.data.skills
        }
        break
    }
  },

  fetchIndustrialArea(state, payload) {
    switch (payload.type) {
      case 'FETCHING_INDUSTRIAL_AREA':
        state.industrialAreaList = {
          isFeching: true,
          errorFeching: false,
          responseData: {}
        }
        break
      case 'FETCHED_INDUSTRIAL_AREA':
        state.industrialAreaList = {
          isFeching: false,
          errorFeching: false,
          responseData: payload.data.data.industrialArea
        }
        break
    }
  },

  submitPostJob(state, payload) {
    switch (payload.type) {
      case 'SUBMITING_POST_JOB':
        state.submitPostJobRes = {
          isSubmittingJob: true,
          errorSubmittingJob: false,
          responseData: {}
        }
        break
      case 'SUBMITED_POST_JOB':
        state.submitPostJobRes = {
          isSubmittingJob: false,
          errorSubmittingJob: false,
          responseData: payload.data
        }
        break
    }
  },

  submitOffshorePostJob(state, payload) {
    switch (payload.type) {
      case 'SUBMITING_OFFSHORE_POST_JOB':
        state.submitOffshorePostJobRes = {
          isSubmittingJob: true,
          errorSubmittingJob: false,
          responseData: {}
        }
        break
      case 'SUBMITED_OFFSHORE_POST_JOB':
        state.submitOffshorePostJobRes = {
          isSubmittingJob: false,
          errorSubmittingJob: false,
          responseData: payload.data
        }
        break
    }
  },

  submitPostContractJob(state, payload) {
    switch (payload.type) {
      case 'SUBMITING_POST_CONTRACT_JOB':
        state.submitPostContractJobRes = {
          isSubmittingContractJob: true,
          errorSubmittingContractJob: false,
          responseData: {}
        }
        break
      case 'SUBMITED_POST_CONTRACT_JOB':
        state.submitPostContractJobRes = {
          isSubmittingContractJob: false,
          errorSubmittingContractJob: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchFoundResume(state, payload) {
    switch (payload.type) {
      case 'FETCHING_RESUME':
        state.findResumeData = {
          isFetchinResume: true,
          errorFetchinResume: false,
          responseData: {}
        }
        break
      case 'FETCHED_RESUME':
        state.findResumeData = {
          isFetchinResume: false,
          errorFetchinResume: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchExactMatchingResumeList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_EXACT_MATCHING_RESUME_LIST':
        state.exactMatchResumeList = {
          isFetchingExactMatchingResumeList: true,
          errorFetchingExactMatchingResumeList: false,
          responseData: {}
        }
        break
      case 'FETCHED_EXACT_MATCHING_RESUME_LIST':
        state.exactMatchResumeList = {
          isFetchingExactMatchingResumeList: false,
          errorFetchingExactMatchingResumeList: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchMatchingResumeList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_MATCHING_RESUME_LIST':
        state.matchResumeList = {
          isFetchingMatchingResumeList: true,
          errorFetchingMatchingResumeList: false,
          responseData: {}
        }
        break
      case 'FETCHED_MATCHING_RESUME_LIST':
        state.matchResumeList = {
          isFetchingMatchingResumeList: false,
          errorFetchingMatchingResumeList: false,
          responseData: payload.data
        }
        break
    }
  },
  setResumeList(state, resumeData) {
    state.resumeList = resumeData
  },
  verifyPostJob(state, payload) {
    switch (payload.type) {
      case 'VERIFYING_POST_JOB':
        state.verifyPostJobRes = {
          isVerifyingJob: true,
          errorVerifyingJob: false,
          responseData: {}
        }
        break
      case 'VERIFIED_POST_JOB':
        state.verifyPostJobRes = {
          isVerifyingJob: false,
          errorVerifyingJob: false,
          responseData: payload.data
        }
        break
    }
  },

  updateExistingJob(state, payload) {
    switch (payload.type) {
      case 'UPDATING_EXISTING_JOB':
        state.updateExistingJobRes = {
          isUpdateExistingJob: true,
          errorUpdateExistingJob: false,
          responseData: {}
        }
        break
      case 'UPDATED_EXISTING_JOB':
        state.updateExistingJobRes = {
          isUpdateExistingJob: false,
          errorUpdateExistingJob: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchNumOfApplicationsList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_NUM_OF_APPLICATIONS_LIST':
        state.numOfApplicationsRes = {
          isFetchingApplicationsList: true,
          errorFetchingApplicationsList: false,
          responseData: {}
        }
        break
      case 'FETCHED_NUM_OF_APPLICATIONS_LIST':
        state.numOfApplicationsRes = {
          isFetchingApplicationsList: false,
          errorFetchingApplicationsList: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchPostJobList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_POST_JOB_LIST':
        state.postJobListRes = {
          isFetchingPostJobList: true,
          errorFetchingPostJobList: false,
          responseData: {}
        }
        break
      case 'FETCHED_POST_JOB_LIST':
        state.postJobListRes = {
          isFetchingPostJobList: false,
          errorFetchingPostJobList: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchPostContractJobList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_POST_CONTRACT_JOB_LIST':
        state.postContractJobListRes = {
          isFetchingPostContractJobList: true,
          errorFetchingPostContractJobList: false,
          responseData: {}
        }
        break
      case 'FETCHED_POST_CONTRACT_JOB_LIST':
        state.postContractJobListRes = {
          isFetchingPostContractJobList: false,
          errorFetchingPostContractJobList: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchFeedbacksList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_FEEDBACKS_LIST':
        state.feedbacksListRes = {
          isFetchingFeedbacksList: true,
          errorFetchingFeedbacksList: false,
          responseData: {}
        }
        break
      case 'FETCHED_FEEDBACKS_LIST':
        state.feedbacksListRes = {
          isFetchingFeedbacksList: false,
          errorFetchingFeedbacksList: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchUnpaidJobList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_UNPAID_JOB_LIST':
        state.unpaidJobList = {
          isFetchingUnpaidJobList: true,
          errorFetchingUnpaidJobList: false,
          responseData: {}
        }
        break
      case 'FETCHED_UNPAID_JOB_LIST':
        state.unpaidJobList = {
          isFetchingUnpaidJobList: false,
          errorFetchingUnpaidJobList: false,
          responseData: payload.data
        }
        break
    }
  },

  getJobFeedbackStatus(state, payload) {
    switch (payload.type) {
      case 'FETCHING_JOB_FEEDBACK_STATUS':
        state.JobFeedbackStatus = {
          isFetchingJobFeedbackStatus: true,
          errorFetchingJobFeedbackStatus: false,
          responseData: {}
        }
        break
      case 'FETCHED_JOB_FEEDBACK_STATUS':
        state.JobFeedbackStatus = {
          isFetchingJobFeedbackStatus: false,
          errorFetchingJobFeedbackStatus: false,
          responseData: payload.data
        }
        break
    }
  },

  deletePostJob(state, payload) {
    switch (payload.type) {
      case 'DELETING_POST_JOB':
        state.deleteJOb = {
          isDeletingPostJob: true,
          errorDeletingPostJob: false,
          responseData: {}
        }
        break
      case 'DELETED_POST_JOB':
        state.deleteJOb = {
          isDeletingPostJob: false,
          errorDeletingPostJob: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchJobDetail(state, payload) {
    switch (payload.type) {
      case 'FETCHING_JOB_DETAIL':
        state.jobDetail = {
          isFetchingJobDetails: true,
          errorFetchingJobDetails: false,
          responseData: {}
        }
        break
      case 'FETCHED_JOB_DETAIL':
        state.jobDetail = {
          isFetchingJobDetails: false,
          errorFetchingJobDetails: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchContractJobDetail(state, payload) {
    switch (payload.type) {
      case 'FETCHING_CONTRACT_JOB_DETAIL':
        state.contractJobDetail = {
          isFetchingContractJobDetails: true,
          errorFetchingContractJobDetails: false,
          responseData: {}
        }
        break
      case 'FETCHED_CONTRACT_JOB_DETAIL':
        state.contractJobDetail = {
          isFetchingContractJobDetails: false,
          errorFetchingContractJobDetails: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchContractFormJobDetail(state, payload) {
    switch (payload.type) {
      case 'FETCHING_CONTRACT_JOB_DETAIL':
        state.jobDetail = {
          isFetchingContractJobDetails: true,
          errorFetchingContractJobDetails: false,
          responseData: {}
        }
        break
      case 'FETCHED_CONTRACT_JOB_DETAIL':
        state.jobDetail = {
          isFetchingContractJobDetails: false,
          errorFetchingContractJobDetails: false,
          responseData: payload.data
        }
        break
    }
  },

  addJobFeedback(state, payload) {
    switch (payload.type) {
      case 'ADDING_JOB_FEEDBACK':
        state.addFeedback = {
          isAddingJobFeedback: true,
          errorAddingJobFeedback: false,
          responseData: {}
        }
        break
      case 'ADDED_JOB_FEEDBACK':
        state.addFeedback = {
          isAddingJobFeedback: false,
          errorAddingJobFeedback: false,
          responseData: payload
        }
        break
    }
  },
  updateJobDetail(state, payload) {
    switch (payload.type) {
      case 'UPDATING_JOB_DETAIL':
        state.updateJob = {
          isUpdatingJobDetails: true,
          errorUpdatingJobDetails: false,
          responseData: {}
        }
        break
      case 'UPDATED_JOB_DETAIL':
        state.updateJob = {
          isUpdatingJobDetails: false,
          errorUpdatingJobDetails: false,
          responseData: payload.data
        }
        break
    }
  },
  updateContractJobDetail(state, payload) {
    switch (payload.type) {
      case 'UPDATING_CONTRACT_JOB_DETAIL':
        state.updateJob = {
          isUpdatingJobDetails: true,
          errorUpdatingJobDetails: false,
          responseData: {}
        }
        break
      case 'UPDATED_CONTRACT_JOB_DETAIL':
        state.updateJob = {
          isUpdatingJobDetails: false,
          errorUpdatingJobDetails: false,
          responseData: payload.data
        }
        break
    }
  },

  updateJobStatus(state, payload) {
    switch (payload.type) {
      case 'UPDATING_JOB_STATUS':
        state.updateJobStatus = {
          isUpdatingJobStatus: true,
          errorUpdatingJobStatus: false,
          responseData: {}
        }
        break
      case 'UPDATED_JOB_STATUS':
        state.updateJobStatus = {
          isUpdatingJobStatus: false,
          errorUpdatingJobStatus: false,
          responseData: payload.data
        }
        break
    }
  },

  activateToPaid(state, payload) {
    switch (payload.type) {
      case 'ACTIVATING_TO_PAID':
        state.activateToPaid = {
          isActivatingToPaid: true,
          errorActivatingToPaid: false,
          responseData: {}
        }
        break
      case 'ACTIVATED_TO_PAID':
        state.activateToPaid = {
          isActivatingToPaid: false,
          errorActivatingToPaid: false,
          responseData: payload.data
        }
        break
    }
  },

  updatepinToTop(state, payload) {
    switch (payload.type) {
      case 'UPDATING_PIN_TO_TOP':
        state.pinToTop = {
          isUpdatingPinTop: true,
          errorUpdatingPinTop: false,
          responseData: {}
        }
        break
      case 'UPDATED_PIN_TO_TOP':
        state.pinToTop = {
          isUpdatingPinTop: false,
          errorUpdatingPinTop: false,
          responseData: payload.data
        }
        break
    }
  },

  updateOrderDetail(state, payload) {
    switch (payload.type) {
      case 'UPDATING_ORDER_DETAIL':
        state.updateOrderSuccess = {
          isUpdatingOrderDetail: true,
          errorUpdatingOrderDetail: false,
          responseData: {}
        }
        break
      case 'UPDATED_ORDER_DETAIL':
        state.updateOrderSuccess = {
          isUpdatingOrderDetail: false,
          errorUpdatingOrderDetail: false,
          responseData: payload.data
        }
        break
    }
  },

  sendContactUs(state, payload) {
    switch (payload.type) {
      case 'SENDING_CONTACT_US':
        state.contactUs = {
          isSendingContactus: true,
          errorSendingContactus: false,
          responseData: {}
        }
        break
      case 'SENT_CONTACT_US':
        state.contactUs = {
          isSendingContactus: false,
          errorSendingContactus: false,
          responseData: payload.data
        }
        break
    }
  },

  resendOTP(state, payload) {
    switch (payload.type) {
      case 'RESENDING_OTP':
        state.resendOtpResponse = {
          isReSendingOTP: true,
          errorReSendingOTP: false,
          responseData: {}
        }
        break
      case 'RESENT_OTP':
        state.resendOtpResponse = {
          isReSendingOTP: false,
          errorReSendingOTP: false,
          responseData: payload.data
        }
        break
    }
  },

  gstVerify(state, payload) {
    switch (payload.type) {
      case 'VERIFYING_GST':
        state.gstVerifyResponse = {
          isVerifyingGst: true,
          errorVerifyingGst: false,
          responseData: {}
        }
        break
      case 'VERIFIED_GST':
        state.gstVerifyResponse = {
          isVerifyingGst: false,
          errorVerifyingGst: false,
          responseData: payload.data
        }
        break
    }
  },

  gstUpload(state, payload) {
    switch (payload.type) {
      case 'UPLOADING_GST':
        state.gstUploadResponse = {
          isUploadingGst: true,
          errorUploadingGst: false,
          responseData: {}
        }
        break
      case 'UPLOADED_GST':
        state.gstUploadResponse = {
          isUploadingGst: false,
          errorUploadingGst: false,
          responseData: payload.data
        }
        break
    }
  },

  checkViewJob(state, payload) {
    switch (payload.type) {
      case 'CHECKING_VIEW_JOB':
        state.checkViewJob = {
          isChecking: true,
          errorChecking: false,
          responseData: {}
        }
        break
      case 'CHECKED_VIEW_JOB':
        state.checkViewJob = {
          isChecking: false,
          errorChecking: false,
          responseData: payload.data
        }
        break
    }
  },

  viewResumeMobile(state, payload) {
    switch (payload.type) {
      case 'VIEW_RESUME_MOBILE':
        state.viewResumeMobile = {
          error: false,
          responseData: payload.data,
          id: payload.id
        }
        break
    }
  },

  getResumeCallback(state, payload) {
    switch (payload.type) {
      case 'GET_RESUME_CALLBACK':
        state.getResumeCallback = {
          error: false,
          responseData: payload.data,
          id: payload.id
        }
        break
    }
  },

  viewWhatsapp(state, payload) {
    switch (payload.type) {
      case 'GET_WHATSAPP':
        state.viewWhatsapp = {
          error: false,
          responseData: payload.data,
          id: payload.id
        }
        break
    }
  },

  fetchingSkillsObj(state, payload) {
    switch (payload.type) {
      case 'FETCHING_SKILL_OBJ':
        state.skillObjs = {
          responseData: payload.data
        }
        break
    }
  },

  shortlistJob(state, payload) {
    switch (payload.type) {
      case 'SHORTLISTING_JOB':
        state.shortlistJobResponse = {
          isSaving: true,
          errorSaving: false,
          responseData: {}
        }
        break
      case 'SHORTLISTED_JOB':
        state.shortlistJobResponse = {
          isSaving: false,
          errorSaving: false,
          responseData: payload.data
        }
        break
    }
  },
  removeJob(state, payload) {
    switch (payload.type) {
      case 'REMOVING_JOB':
        state.removeJobResponse = {
          isRemoving: true,
          errorRemoving: false,
          responseData: {}
        }
        break
      case 'REMOVED_JOB':
        state.removeJobResponse = {
          isRemoving: false,
          errorRemoving: false,
          responseData: payload.data
        }
        break
    }
  }
}

const actions = {
  shortlistJob({ commit }, _obj) {
    commit('shortlistJob', { type: 'SHORTLISTING_JOB' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.post(urlConstant.baseUrl + urlConstant.shortlistJob, _obj, {
      headers: { token: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('shortlistJob', { type: 'SHORTLISTED_JOB', data: res.data })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },
  removeJob({ commit }, _obj) {
    commit('removeJob', { type: 'REMOVING_JOB' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.post(urlConstant.baseUrl + urlConstant.removejob, _obj, {
      headers: { token: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('removeJob', { type: 'REMOVED_JOB', data: res.data })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },
  actionCheckViewJob({ commit }, _obj) {
    commit('checkViewJob', { type: 'CHECKING_VIEW_JOB' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    // const { id, jobId, contractJobId, type } = _obj;
    // let params;
    // if (jobId) {
    //   params = `id=${id}&jobId=${jobId}&type=${type}`;
    // }
    // if (contractJobId) {
    //   params = `id=${id}&contractJobId=${contractJobId}&type=${type}`;
    // }
    APIService.post(`${urlConstant.baseUrl}${urlConstant.paidPerk}`, _obj, {
      headers: { Authorization: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          commit('checkViewJob', { type: 'CHECKED_VIEW_JOB', data: res.data })
        }
      })
      .catch((err) => {
        console.log('checkViewJob', err)
      })
  },

  actionViewResumeMobile({ commit }, _obj) {
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    const { id } = _obj
    if (!jwtToken || !userId) {
      localStorage.setItem('listingPagePrevPath', window.location.pathname)
      window.location.replace('./login')
      return
    }
    APIService.get(`${urlConstant.baseUrl}/employer/get-candidate-contact?userId=${id}`, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          commit('viewResumeMobile', {
            type: 'VIEW_RESUME_MOBILE',
            data: res.data,
            id: id
          })
        }
      })
      .catch((err) => {
        console.log('viewResumeMobile', err)
      })
  },

  actionViewWhatsapp({ commit }, _obj) {
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    const { id } = _obj
    if (!jwtToken || !userId) {
      localStorage.setItem('listingPagePrevPath', window.location.pathname)
      window.location.replace('./login')
      return
    }
    APIService.get(`${urlConstant.baseUrl}/employer/get-whatsapp?userId=${id}`, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          commit('viewWhatsapp', {
            type: 'GET_WHATSAPP',
            data: res.data,
            id: id
          })
        }
      })
      .catch((err) => {
        console.log('viewWhatsapp', err)
      })
  },

  actionGetResumeCallback({ commit }, _obj) {
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    const { id } = _obj
    if (!jwtToken || !userId) {
      localStorage.setItem('listingPagePrevPath', window.location.pathname)
      window.location.replace('./login')
      return
    }
    APIService.get(`${urlConstant.baseUrl}/employer/get-call-back-resume?userId=${id}`, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          commit('getResumeCallback', {
            type: 'GET_RESUME_CALLBACK',
            data: res.data,
            id: id
          })
        }
      })
      .catch((err) => {
        console.log('getResumeCallback', err)
      })
  },

  actionResendOTP({ commit }, _obj) {
    commit('resendOTP', { type: 'RESENDING_OTP' })
    // console.log("**********************************KKKK", _obj);
    APIService.post(urlConstant.baseUrl + urlConstant.resendOtp, _obj)
      .then((res) => {
        if (res.data) {
          commit('resendOTP', { type: 'RESENT_OTP', data: res.data })
        }
      })
      .catch((err) => {
        console.log('resendOTP', err)
      })
  },

  async actionVerifyGst({ commit }, obj) {
    commit('gstVerify', { type: 'VERIFYING_GST' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    await APIService.post(urlConstant.baseUrl + urlConstant.verifyGst, obj, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res) {
          commit('gstVerify', { type: 'VERIFIED_GST', data: res.data })
        }
      })
      .catch((err) => {
        console.log('gstVerify', err)
      })
  },

  async actionUploadGst({ commit }, obj) {
    commit('gstUpload', { type: 'UPLOADING_GST' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    await APIService.post(urlConstant.baseUrl + urlConstant.uploadGst, obj, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res) {
          commit('gstUpload', { type: 'UPLOADED_GST', data: res.data })
        }
      })
      .catch((err) => {
        console.log('gstUpload', err)
      })
  },

  actionSubmitContactUs({ commit }, _obj) {
    commit('sendContactUs', { type: 'SENDING_CONTACT_US' })
    APIService.post(urlConstant.baseUrl + urlConstant.contactus, _obj)
      .then((res) => {
        if (res.data) {
          commit('sendContactUs', { type: 'SENT_CONTACT_US', data: res.data })
        }
      })
      .catch((err) => {
        console.log('sendContactUs', err)
      })
  },

  actionUpdateOrderDet({ commit }, _obj) {
    commit('updateOrderDetail', { type: 'UPDATING_ORDER_DETAIL' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.post(urlConstant.baseUrl + urlConstant.updateOrder, _obj, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          commit('updateOrderDetail', {
            type: 'UPDATED_ORDER_DETAIL',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('updateOrderDetail', err)
      })
  },

  actionpinToTop({ commit }, jobId) {
    commit('updatepinToTop', { type: 'UPDATING_PIN_TO_TOP' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(urlConstant.baseUrl + urlConstant.pinToTop + '?jobId=' + jobId, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('updatepinToTop', {
            type: 'UPDATED_PIN_TO_TOP',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('updatepinToTop', err)
      })
  },

  async actionAddJobFeedback({ commit }, obj) {
    commit('addJobFeedback', { type: 'ADDING_JOB_FEEDBACK' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    try {
      const res = await APIService.post(urlConstant.baseUrl + urlConstant.addJobFeedback, obj, {
        headers: { Authorization: jwtToken, userid: userId }
      })
      if (res.data) {
        // console.log(res.data);
        commit('addJobFeedback', {
          type: 'ADDED_JOB_FEEDBACK',
          data: res.data
        })
      }
    } catch (err) {
      console.log('addJobFeedback', err)
    }
  },
  actionUpdateJob({ commit }, obj) {
    commit('updateJobDetail', { type: 'UPDATING_JOB_DETAIL' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.put(
      `${urlConstant.baseUrl}${urlConstant.employeeProfile}/${obj.jobId}${urlConstant.updateJob}`,
      obj,
      { headers: { Authorization: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('updateJobDetail', {
            type: 'UPDATED_JOB_DETAIL',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('updateJobDetail', err)
      })
  },

  actionUpdateContractJob({ commit }, obj) {
    commit('updateContractJobDetail', { type: 'UPDATING_CONTRACT_JOB_DETAIL' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.put(
      `${urlConstant.baseUrl}${urlConstant.employeeProfile}/${obj.jobId}${urlConstant.updateJob}`,
      obj,
      {
        headers: { Authorization: jwtToken, userid: userId }
      }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('updateContractJobDetail', {
            type: 'UPDATED_CONTRACT_JOB_DETAIL',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('updateContractJobDetail', err)
      })
  },

  actionUpdateJobStatus({ commit }, obj) {
    commit('updateJobStatus', { type: 'UPDATING_JOB_STATUS' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.post(urlConstant.baseUrl + '/update-job-status', obj, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('updateJobStatus', {
            type: 'UPDATED_JOB_STATUS',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('updateJobStatus', err)
      })
  },

  actionActivateToPaid({ commit }, obj) {
    commit('activateToPaid', { type: 'ACTIVATING_TO_PAID' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.post(
      urlConstant.baseUrl + urlConstant.employeeProfile + urlConstant.activateToPaid,
      obj,
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('activateToPaid', {
            type: 'ACTIVATED_TO_PAID',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('activateToPaid', err)
      })
  },

  actionGetJobDetail({ commit }, jobId) {
    commit('fetchJobDetail', { type: 'FETCHING_JOB_DETAIL' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(
      `${urlConstant.baseUrl}${urlConstant.employeeProfile}/${jobId}${urlConstant.viewJob}`,
      { headers: { Authorization: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchJobDetail', {
            type: 'FETCHED_JOB_DETAIL',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchJobDetail', err)
      })
  },

  actionGetContractJobDetail({ commit }, jobId) {
    commit('fetchContractJobDetail', { type: 'FETCHING_CONTRACT_JOB_DETAIL' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')

    APIService.get(
      urlConstant.baseUrl +
        urlConstant.apiEndpointUri +
        '/' +
        jobId +
        urlConstant.fetchContractJobDetails,
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchContractJobDetail', {
            type: 'FETCHED_CONTRACT_JOB_DETAIL',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchContractJobDetail', err)
      })
  },

  actionGetContractFormJobDetail({ commit }, jobId) {
    commit('fetchContractFormJobDetail', {
      type: 'FETCHING_CONTRACT_JOB_DETAIL'
    })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')

    APIService.get(
      urlConstant.baseUrl +
        urlConstant.apiEndpointUri +
        '/' +
        jobId +
        urlConstant.fetchContractJobDetails,
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchContractFormJobDetail', {
            type: 'FETCHED_CONTRACT_JOB_DETAIL',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchContractFormJobDetail', err)
      })
  },

  actionDeleteJob({ commit }, jobId) {
    commit('deletePostJob', { type: 'DELETING_POST_JOB' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(
      urlConstant.baseUrl + urlConstant.employeeProfile + '/' + jobId + '/delete-job',
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('deletePostJob', { type: 'DELETED_POST_JOB', data: res.data })
        }
      })
      .catch((err) => {
        console.log('deletePostJob', err)
      })
  },

  actionUpdateExistingJob({ commit }, obj) {
    commit('updateExistingJob', { type: 'UPDATING_EXISTING_JOB' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(
      urlConstant.baseUrl +
        urlConstant.updateExistingOrder +
        '?jobId=' +
        obj.jobId +
        '&id=' +
        obj.id,
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('updateExistingJob', {
            type: 'UPDATED_EXISTING_JOB',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('updateExistingJob', err)
      })
  },
  actionNumOfApplicationsList({ commit }, obj) {
    commit('fetchNumOfApplicationsList', {
      type: 'FETCHING_NUM_OF_APPLICATIONS_LIST'
    })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(
      urlConstant.baseUrl + urlConstant.numOfApplicationsList + '?page=' + obj.pageNum,
      { headers: { Authorization: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchNumOfApplicationsList', {
            type: 'FETCHED_NUM_OF_APPLICATIONS_LIST',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchNumOfApplicationsList', err)
      })
  },
  actionGetPostedJobList({ commit }, obj) {
    commit('fetchPostJobList', { type: 'FETCHING_POST_JOB_LIST' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(
      `${urlConstant.baseUrl}${urlConstant.postedJobList}?active=${obj.activeStatus}&page=${obj.pageNum}`,
      { headers: { Authorization: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchPostJobList', {
            type: 'FETCHED_POST_JOB_LIST',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchPostJobList', err)
      })
  },
  actionGetPostedContractJobList({ commit }, obj) {
    commit('fetchPostContractJobList', {
      type: 'FETCHING_POST_CONTRACT_JOB_LIST'
    })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(
      urlConstant.baseUrl + urlConstant.postedContractJobList + '?page=' + obj.pageNum,
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchPostContractJobList', {
            type: 'FETCHED_POST_CONTRACT_JOB_LIST',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchPostContractJobList', err)
      })
  },
  actionGetFeedbacksList({ commit }, obj) {
    commit('fetchFeedbacksList', { type: 'FETCHING_FEEDBACKS_LIST' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(
      `${urlConstant.baseUrl}${urlConstant.getFeedbackList}?active=${obj.activeStatus}&page=${obj.pageNum}`,
      { headers: { Authorization: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchFeedbacksList', {
            type: 'FETCHED_FEEDBACKS_LIST',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchFeedbacksList', err)
      })
  },

  actionGetUnpaidJobList({ commit }, obj) {
    commit('fetchUnpaidJobList', { type: 'FETCHING_UNPAID_JOB_LIST' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(
      urlConstant.baseUrl +
        urlConstant.unpaidJobList +
        '?active=' +
        obj.activeStatus +
        '&page=' +
        obj.pageNum,
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchUnpaidJobList', {
            type: 'FETCHED_UNPAID_JOB_LIST',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchUnpaidJobList', err)
      })
  },

  actionGetJobFeedbackStatus({ commit }, obj) {
    commit('getJobFeedbackStatus', { type: 'FETCHING_JOB_FEEDBACK_STATUS' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    APIService.get(urlConstant.baseUrl + urlConstant.getJobFeedbackStatus + '?id=' + obj.id, {
      headers: { jwt: jwtToken, userid: userId }
    })
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('getJobFeedbackStatus', {
            type: 'FETCHED_JOB_FEEDBACK_STATUS',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('getJobFeedbackStatus', err)
      })
  },

  actionVerifyPostJob({ commit }, _obj) {
    commit('verifyPostJob', { type: 'VERIFYING_POST_JOB' })
    APIService.post(urlConstant.baseUrl + urlConstant.veriyfyPostJob, _obj)
      .then((res) => {
        if (res.data) {
          commit('verifyPostJob', {
            type: 'VERIFIED_POST_JOB',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('verifyPostJob', err)
      })
  },

  actionSubmitPostJob({ commit }, _obj) {
    commit('submitPostJob', { type: 'SUBMITING_POST_JOB' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    const headerInfo = userId ? { headers: { jwt: jwtToken, userid: userId } } : {}
    APIService.post(urlConstant.baseUrl + urlConstant.submitPostJob, _obj, headerInfo)
      .then((res) => {
        if (res.data) {
          // console.log("actionSubmitPostJob", res.data);
          commit('submitPostJob', {
            type: 'SUBMITED_POST_JOB',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchEducations', err)
      })
  },

  actionSubmitOffshorePostJob({ commit }, _obj) {
    commit('submitOffshorePostJob', { type: 'SUBMITING_OFFSHORE_POST_JOB' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    const headerInfo = userId ? { headers: { jwt: jwtToken, userid: userId } } : {}
    APIService.post(urlConstant.baseUrl + urlConstant.submitOffshorePostJob, _obj, headerInfo)
      .then((res) => {
        if (res.data) {
          commit('submitOffshorePostJob', {
            type: 'SUBMITED_OFFSHORE_POST_JOB',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchEducations', err)
      })
  },

  actionSubmitPostContractJob({ commit }, _obj) {
    commit('submitPostContractJob', { type: 'SUBMITING_POST_CONTRACT_JOB' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    const headerInfo = userId ? { headers: { jwt: jwtToken, userid: userId } } : {}
    APIService.post(urlConstant.baseUrl + urlConstant.submitPostContractJob, _obj, headerInfo)
      .then((res) => {
        if (res.data) {
          commit('submitPostContractJob', {
            type: 'SUBMITED_POST_CONTRACT_JOB',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('Error Contract JobPost', err)
      })
  },

  // find resume API
  findResume({ commit }, _obj) {
    commit('fetchFoundResume', { type: 'FETCHING_RESUME' })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')
    const headerInfo = userId ? { headers: { jwt: jwtToken, userid: userId } } : {}
    APIService.post(urlConstant.baseUrl + urlConstant.findResumeData, _obj, headerInfo)
      .then((res) => {
        if (res.data?.data) {
          const resumeData = res.data.data
          commit('fetchFoundResume', {
            type: 'FETCHED_RESUME',
            data: resumeData
          })
        } else {
          let obj = {
            dataObject: { message: 'Records not found' },
            statusCode: 404,
            statusMessage: 'Records not found'
          }
          commit('fetchFoundResume', {
            type: 'FETCHED_RESUME',
            data: obj
          })
        }
      })
      .catch((err) => {
        console.log('fetchFoundResume', err)
      })
  },

  async actionFetchExactMatchingResumeList({ commit }, payLoad) {
    commit('fetchExactMatchingResumeList', {
      type: 'FETCHING_EXACT_MATCHING_RESUME_LIST'
    })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')

    await APIService.get(
      urlConstant.baseUrl +
        urlConstant.getExactMatchingResume +
        '?page=' +
        payLoad.pageNum +
        '&id=' +
        payLoad.id,
      { headers: { Authorization: jwtToken, userid: userId } }
    )

      .then((res) => {
        if (res.data) {
          commit('fetchExactMatchingResumeList', {
            type: 'FETCHED_EXACT_MATCHING_RESUME_LIST',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchExactMatchingResumeList', err)
      })
  },
  async actionFetchMatchingResumeList({ commit }, payLoad) {
    commit('fetchMatchingResumeList', {
      type: 'FETCHING_MATCHING_RESUME_LIST'
    })
    const jwtToken = Cookies.get('authToken')
    const userId = Cookies.get('userId')

    await APIService.get(
      urlConstant.baseUrl +
        urlConstant.getMatchingResume +
        '?page=' +
        payLoad.pageNum +
        '&id=' +
        payLoad.id,
      { headers: { jwt: jwtToken, userid: userId } }
    )

      .then((res) => {
        if (res.data) {
          commit('fetchMatchingResumeList', {
            type: 'FETCHED_MATCHING_RESUME_LIST',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchMatchingResumeList', err)
      })
  },

  setSearchResume({ commit }, data) {
    if (data) {
      commit('setResumeList', { data })
    } else {
      commit('setResumeList', {})
    }
  },

  actionSearchSkill({ commit }, keySearch) {
    commit('fetchSkills', { type: 'FETCHING_SKILLS' })
    APIService.get(`${urlConstant.baseUrl}${urlConstant.searchSkill}?skill=${keySearch}`)
      .then((res) => {
        if (res.data) {
          commit('fetchSkills', { type: 'FETCHED_SKILLS', data: res.data })
        }
      })
      .catch((err) => {
        console.log('fetchEducations', err)
      })
  },

  actionSearchSuggestedSkill({ commit }, keySearch) {
    commit('fetchSuggestedSkills', { type: 'FETCHING_SKILLS' })
    APIService.get(`${urlConstant.baseUrl}${urlConstant.suggestedSkill}?profile=${keySearch}`)
      .then((res) => {
        if (res.data) {
          commit('fetchSuggestedSkills', {
            type: 'FETCHED_SKILLS',
            data: res.data
          })
        }
      })
      .catch(() => {
        //
      })
  },

  actionSearchIndustrialArea({ commit }, keySearch) {
    commit('fetchIndustrialArea', { type: 'FETCHING_INDUSTRIAL_AREA' })
    APIService.get(`${urlConstant.baseUrl}${urlConstant.industrailArea}?city=${keySearch}`)
      .then((res) => {
        if (res.data) {
          commit('fetchIndustrialArea', {
            type: 'FETCHED_INDUSTRIAL_AREA',
            data: res.data
          })
        }
      })
      .catch(() => {
        //
      })
  },

  actionFetchEducations({ commit }) {
    commit('fetchEducations', { type: 'FETCHING_EDUCATION' })
    APIService.get(urlConstant.baseUrl + urlConstant.fetchEducations)
      .then((res) => {
        if (res.data) {
          commit('fetchEducations', {
            type: 'FETCHED_EDUCATION',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchEducations', err)
      })
  },

  actionFetchIndustries({ commit }, keySearch) {
    commit('fetchIndustries', { type: 'FETCHING_INDUSTRIES' })
    APIService.get(urlConstant.baseUrl + urlConstant.fetchIndustries)
      .then((res) => {
        if (res.data) {
          let final = res.data
          if (keySearch != '') {
            let temp = final?.data?.industry.filter((industry) => {
              return industry.name.toLowerCase().includes(keySearch.toLowerCase())
            })
            final.data.industry = temp
          }
          commit('fetchIndustries', {
            type: 'FETCHED_INDUSTRIES',
            data: final
          })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },

  actionFetchIndustriesList({ commit }) {
    commit('fetchIndustriesList', { type: 'FETCHING_INDUSTRIES_LIST' })
    APIService.get(urlConstant.baseUrl + urlConstant.fetchIndustriesList)
      .then((res) => {
        if (res.data) {
          let final = res.data
          commit('fetchIndustriesList', {
            type: 'FETCHED_INDUSTRIES_LIST',
            data: final
          })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },
  // actionFetchNewIndustries({ commit }, keySearch) {
  //   commit("fetchNewIndustries", { type: "FETCHING_NEW_INDUSTRIES" });
  //   APIService.get(urlConstant.baseUrl + urlConstant.fetchNewIndustries)
  //     .then((res) => {
  //       if (res.data) {
  //         let final = res.data;
  //         if (keySearch != "") {
  //           let temp = final?.data?.industry.filter((industry) => {
  //             return industry.name
  //               .toLowerCase()
  //               .includes(keySearch.toLowerCase());
  //           });
  //           final.data.industry = temp;
  //         }
  //         commit("fetchNewIndustries", {
  //           type: "FETCHED_NEW_INDUSTRIES",
  //           data: final,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("createTopic", err);
  //     });
  // },
  actionFetchAllSkills({ commit }) {
    commit('fetchAllSkills', { type: 'FETCHING_ALL_SKILLS' })
    APIService.get(urlConstant.baseUrl + urlConstant.fetchAllSkills)
      .then((res) => {
        if (res.data) {
          // console.log("---fetchAllSkills---", res.data);
          commit('fetchAllSkills', {
            type: 'FETCHED_ALL_SKILLS',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchAllSkills', err)
      })
  },
  actionFetchAllLocations({ commit }) {
    commit('fetchAllLocations', { type: 'FETCHING_ALL_LOCATIONS' })
    APIService.get(urlConstant.baseUrl + urlConstant.fetchAllLocations)
      .then((res) => {
        if (res.data) {
          // console.log("---fetchAllLocations---", res.data);
          commit('fetchAllLocations', {
            type: 'FETCHED_ALL_LOCATIONS',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchAllLocations', err)
      })
  },

  actionGetFunctionalAreas({ commit }) {
    commit('fetchFunctionalAreas', { type: 'FETCHING_FUNC_AREA' })
    APIService.get(urlConstant.baseUrl + urlConstant.functionalAreas)
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit('fetchFunctionalAreas', {
            type: 'FETCHED_FUNC_AREA',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('fetchFunctionalAreas', err)
      })
  },

  fetchCitySearchList({ commit }, _searchKeyword) {
    // console.log(_searchKeyword);
    commit('fetchCitySearch', { type: 'FETCHING_CITY_SEARCH' })
    APIService.get(
      `${urlConstant.baseUrl}${urlConstant.searchCities}?location=${_searchKeyword}&fromAlias=null`
    )
      .then((res) => {
        if (res.data) {
          commit('fetchCitySearch', {
            type: 'FETCHED_CITY_SEARCH',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },

  fetchOffshoreCitySearchList({ commit }, _searchKeyword) {
    // console.log(_searchKeyword);
    commit('fetchOffshoreCitySearch', {
      type: 'FETCHING_OFFSHORE_CITY_SEARCH'
    })
    APIService.get(
      urlConstant.baseUrl +
        urlConstant.searchOffshoreCities +
        '?location=' +
        _searchKeyword.location +
        '&country=' +
        _searchKeyword.country +
        ''
    )
      .then((res) => {
        if (res.data) {
          commit('fetchOffshoreCitySearch', {
            type: 'FETCHED_OFFSHORE_CITY_SEARCH',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },

  // fetchLocalSearchList({ commit }, _searchKeyword) {
  //   commit("fetchLocalitySearch", { type: "FETCHING_LOCALITY_SEARCH" });
  //   APIService.get(
  //     urlConstant.baseUrl +
  //       urlConstant.searchLocalities +
  //       "?location=" +
  //       _searchKeyword +
  //       "&fromAlias=null"
  //   )
  //     .then((res) => {
  //       if (res.data) {
  //         // console.log('searchLocal', res.data);
  //         commit("fetchCitySearch", {
  //           type: "FETCHED_CITY_SEARCH",
  //           data: res.data,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("createTopic", err);
  //     });
  // },

  fetchLocalitySearchList({ commit }, _obj) {
    commit('fetchLocalitySearch', { type: 'FETCHING_LOCALITY_SEARCH' })
    APIService.get(
      urlConstant.baseUrl +
        urlConstant.searchLocalities +
        '?city=' +
        _obj.city +
        '&location=' +
        _obj.keyword
    )
      .then((res) => {
        if (res.data) {
          // console.log("LOCALITY RESPONSE", res.data);
          commit('fetchLocalitySearch', {
            type: 'FETCHED_LOCALITY_SEARCH',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },

  actionFetchDatabasePlan({ commit }) {
    commit('fetchDatabasePlan', { type: 'FETCHING_DATABASE_PLAN' })
    APIService.get(urlConstant.baseUrl + urlConstant.databasePlan)
      .then((res) => {
        if (res.data) {
          commit('fetchDatabasePlan', {
            type: 'FETCHED_DATABASE_PLAN',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },
  actionFetchPremiumPlan({ commit }) {
    commit('fetchPremiumPlan', { type: 'FETCHING_PREMIUM_PLAN' })
    APIService.get(urlConstant.baseUrl + urlConstant.premiumPlan)
      .then((res) => {
        if (res.data) {
          commit('fetchPremiumPlan', {
            type: 'FETCHED_PREMIUM_PLAN',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('createTopic', err)
      })
  },
  actionFetchSpecialPlan({ commit }, param) {
    commit('fetchSpecialPlan', { type: 'FETCHING_SPECIAL_PLAN' })
    APIService.get(`${urlConstant.baseUrl}${urlConstant.specialPlan}`
    // , {
    //   headers: {
    //     jwt: Cookies.get('authToken'),
    //     userid: Cookies.get('userId')
    //   }
    // }
    )
      .then((res) => {
        if (res.data) {
          commit('fetchSpecialPlan', {
            type: 'FETCHED_SPECIAL_PLAN',
            data: res.data
          })
        }
      })
      .catch((err) => {
        console.log('Error', err)
      })
  },

  actionFetchAddSkills({ commit }, _obj) {
    commit('fetchingSkillsObj', { type: 'FETCHING_SKILL_OBJ', data: _obj })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
